import React, { FC } from 'react'

import { IconEmptySearch } from '@avantstay/backoffice-vectors'

import { EmptySearchProps } from '@new/__global/components/EmptySearch/_types'

import * as S from './EmptySearch.styles'

export const EmptySearch: FC<EmptySearchProps> = ({
  icon,
  title,
  description,
  children,
  showAction,
  actionTitle,
  onClick,
  dataCy,
  bgColor,
  className,
}) => {
  return (
    <S.Root className={className} full bgColor={bgColor}>
      {icon ? icon : <IconEmptySearch />}
      {!!title && <S.Title>{title}</S.Title>}
      {!!description && <S.Description>{description}</S.Description>}

      {showAction && (
        <S.ActionButton onClick={onClick} data-cy={dataCy}>
          {actionTitle ?? 'Reset Filter'}
        </S.ActionButton>
      )}

      {!!children && <S.Actions>{children}</S.Actions>}
    </S.Root>
  )
}
